import { gql } from '@apollo/client';

import { TransmissionEventsFragment } from '../fragments/transmissionEventsFragment.gql';

/**
 * Query to fetch transmission events for a given entity (order/email)
 * Used to track delivery status and failures
 *
 * @param ofId - The ID of the entity to fetch transmission events for
 */
export const GetTransmissionEventsQuery = gql`
  query GetTransmissionEvents($ofId: ID!) {
    transmissionEvents(ofId: $ofId) {
      ...TransmissionEventsFragment
    }
  }
  ${TransmissionEventsFragment}
`;
